import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigationHeartbeat } from '../../hooks/useNavigationHeartbeat';
import { useRememberLastScreen } from '../../hooks/useRememberLastScreen';
import { useSidebarLayout } from '../../hooks/useSidebarLayout';
import { Sidebar } from './Sidebar';
import { TopHeader } from './TopHeader';

export function MainLayout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { collapsed, desktopWidth, isResizing, toggleCollapsed, beginResize } = useSidebarLayout();
  useNavigationHeartbeat();
  useRememberLastScreen();

  return (
    <div className="flex h-full min-h-0 overflow-hidden bg-baruk-surface">
      <Sidebar
        mobileOpen={mobileSidebarOpen}
        onCloseMobile={() => setMobileSidebarOpen(false)}
        collapsed={collapsed}
        desktopWidth={desktopWidth}
        isResizing={isResizing}
        onToggleCollapse={toggleCollapsed}
        onResizeStart={beginResize}
      />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <TopHeader onToggleSidebar={() => setMobileSidebarOpen((open) => !open)} />
        <main className="relative min-h-0 flex-1 overflow-auto p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
